// extracted by mini-css-extract-plugin
export default {"fuwenben":"JiDiPanes_fuwenben__DsHjl"};